import { render, staticRenderFns } from "./booking-card-v2.vue?vue&type=template&id=221cfb97&scoped=true&"
import script from "./booking-card-v2.vue?vue&type=script&lang=js&"
export * from "./booking-card-v2.vue?vue&type=script&lang=js&"
import style0 from "./booking-card-v2.vue?vue&type=style&index=0&id=221cfb97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221cfb97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSheet,VSpacer})
